<div class="empty-page">
    <div >
        <router-outlet></router-outlet>
    </div>
</div>
